export const modalNames = {
    errorModal: 'ERROR_MODAL',
    progressModal: 'PROGRESS_MODAL',
};
